export const MAX_BATCH_SIZE = 1000;

export const USE_NO_SHOW_DISCLAIMER = 'Note: Use "Mark as no-showed" for participants that did not attend';

export const REPORT_MISUSE_DISCLAIMER =
  'Note: Use only if the participant misrepresented themselves or provided false information. This participant will be reported to our panel provider and be unable to participate in future studies with your team. They will not count towards your Participant total, recruitment fees or incentive total.';
